// extracted by mini-css-extract-plugin
var _1 = "File-module__animateUploadProgressBarWidth--bNPIa";
var _2 = "File-module__animatedBackground--xVm3_";
var _3 = "File-module__container--SyrGk";
var _4 = "File-module__fileContent--ZHQ7F";
var _5 = "File-module__pdfEmbed--TzXSN";
var _6 = "File-module__pdfFileContainer--kKC9R";
var _7 = "File-module__size--BG44s";
var _8 = "File-module__uploading--_USb8";
var _9 = "File-module__wrapper--eDmfj";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "fileContent", _5 as "pdfEmbed", _6 as "pdfFileContainer", _7 as "size", _8 as "uploading", _9 as "wrapper" }
